<template>
  <div class="dt-details cmp-distribution-contract_details">
    <div class="dt-details--header">
      {{ selectedContractDetails.contract.contract_name || "Contract Details" }}
    </div>
    <div class="dt-details--body" v-if="selectedContractDetails.contract">
      <div class="dt-details--col" style="max-width: 40%; border-left: 0px">
        <div class="dt-details--row">
          <div
            class="fc2 valued disabled fc2-textfield"
            style="
              height: 32px;
              --fc2-lw: 110px;
              --fc2-cw: 150px;
              --fc2-height: 32px;
              --bb: none;
              width: 100%;
            "
            placeholder="Account Name"
          >
            <label class="fc2-label txtov" title="Account Name"
              ><span>Royalty Account</span></label
            >
            <div
              class="ut-link ut-text-accent5 txtov"
              style="text-align: left; width: var(--fc2-cw); padding: 5px"
              @click="onRoyaltyAccountClick"
            >
              {{
                selectedContractDetails &&
                selectedContractDetails.royalty_account &&
                selectedContractDetails.royalty_account.royalty_account_name
              }}
            </div>
          </div>
        </div>
        <div
          class="dt-details--row"
          style="border-right: 1px solid var(--sprt-7)"
        >
          <TextField2
            :id="'contract_name'"
            :placeholder="$t('contract_name')"
            :label="$t('contract_name')"
            :value="selectedContractDetails.contract.contract_name"
            @blur="onTextFieldValueChange"
            lw="95px"
            cw="105px"
            style="width: 100%"
            bb="none"
            :disabled="loading"
          />
        </div>
        <div
          class="dt-details--row"
          style="border-right: 1px solid var(--sprt-7)"
        >
          <Dropdown2
            :disabled="loading || selectedContractDetails.disabled"
            :label="$t('contract_status')"
            :placeholder="$t('contract_status')"
            status
            :options="selectedContractDetails.labelStatusesTV"
            :selected="
              selectedContractDetails.labelStatusesTV.find(
                (e) =>
                  e.value == selectedContractDetails.contract.label_status_id
              )
            "
            v-on:selectedChange="(e) => onDropdownChange('label_status_id', e)"
            lw="95px"
            cw="105px"
            bb="none"
            style="width: 100%"
          />
        </div>
      </div>
      <div class="dt-details--col" style="max-width: 20.5%; border-left: 0px">
        <div class="dt-details--row">
          <div
            class="fc2 valued disabled fc2-textfield"
            style="height: 32px"
          >
            <img
              src="static/icons/arrows/arrow-left.svg"
              @click.stop="(e) => onPrevClick()"
              class="dt-icon v5 s1 ut-center"
              alt
            />
            <img
              src="static/icons/arrows/arrow-right.svg"
              @click.stop="(e) => onNextClick()"
              class="dt-icon v5 s1 ut-center"
              alt
            />
            <!-- {{ contractIds }}
    
            {{ currentContractIdIndex }} -->
          </div>
        </div>
        <div
          class="dt-details--row"
          style="border-right: 1px solid var(--sprt-7)"
        >
          <DatePicker2
            id="contract_start"
            :label="$t('start')"
            :value="selectedContractDetails.contract.contract_start"
            @input="onDateUpdate"
            lw="50px"
            cw="150px"
            bb="none"
            style="width: 100%"
            :disabled="loading"
          />
        </div>
        <div
          class="dt-details--row"
          style="border-right: 1px solid var(--sprt-7)"
        >
          <DatePicker2
            id="contract_end"
            :label="$t('end')"
            :value="selectedContractDetails.contract.contract_end"
            @input="onDateUpdate"
            lw="50px"
            cw="150px"
            bb="none"
            style="width: 100%"
            :disabled="loading"
          />
        </div>
      </div>
      <div class="dt-details--col" style="max-width: 40%; border-left: 0px">
        <div class="dt-details--row">
          <div
            class="fc2 valued disabled fc2-textfield"
            style="height: 32px"
          ></div>
        </div>
        <div class="dt-details--row">
          <TextField2
            :id="'contract_key'"
            :placeholder="$t('contract_key')"
            :label="$t('contract_key')"
            :value="selectedContractDetails.contract.contract_key"
            @blur="onTextFieldValueChange"
            lw="118px"
            cw="105px"
            style="width: 100%"
            bb="none"
            :disabled="loading"
          />
        </div>
        <div class="dt-details--row">
          <div class="setup-row ut-flex" style="width: 100%">
            <div
              style="
                margin-left: 10px;
                margin-right: 5px;
                height: 32px;
                flex: 1;
                max-width: 124px;
                width: 124px;
              "
              class="ut-flex no-right-padding"
            >
              <label style="color: var(--text-5)" class="label-title txtov">
                {{ $dft.snakeCaseToWords("Use as Template") }}
              </label>
              <div
                style="padding-left: 5px; padding-right: 5px"
                class="no-label"
              >
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    :name="'template_flag'"
                    :id="'template_flag'"
                    :checked="selectedContractDetails.contract.template_flag"
                    @click="(e) => onCheckboxChange('template_flag', e)"
                    :disabled="loading"
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
            </div>
            <TextField2
              v-show="selectedContractDetails.contract.template_flag"
              :bb="'0px'"
              style="flex: 1"
              :showLabel="false"
              :id="'template_name'"
              :placeholder="$t('template_name')"
              :label="$t('template_name')"
              :value="selectedContractDetails.contract.template_name"
              @blur="onTextFieldValueChange"
              :cw="'215px'"
              :lw="'0px'"
              :disabled="loading"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DistributionStoreNamespace as storeNS } from "../../store";
import EditableSpan from "@/plugins/editable-span/editable-span";
import { createDropdownConfig } from "@/plugins/dropdown";
import { createTextFieldConfig, EventHooks } from "@plugins/text-field";
import { mapGetterObject } from "../../../../store/global";
import { royaltyAccountsListLDTRoutes } from "../../router/routes";
import { royaltyContractsListLDTRoutes } from "../../router/routes";

export default {
  mounted: async function () {
   
    //this.contractIds = this.selectedContractDetails?.contractID||[]

   // const currentSelectedContract = this.contractIds.find(x=>x==this.selectedContractDetails.contract.contract_id)
    

    //this.currentContractIdIndex = this.contractIds.indexOf(this.currentSelectedContract);

    console.log(this.currentContractIdIndex,":::::::::OOOOOOOOOSAFDFFFFFFFFFFF",this.contractIds)
  },
  components: {
    EditableSpan,
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },
      //contractIds:[],
      currentContractIdIndex:0,
      dropdownConfig: createDropdownConfig({
        iconHoverStyle: 1,
      }),
      vatHandlingList: [
        {
          text: "VAT on top",
          value: 1,
        },
        {
          text: "Including VAT",
          value: 2,
        },
        {
          text: "No VAT",
          value: 3,
        },
      ],
    };
  },
  props: {
    selectedContractDetails: {
      type: Object,
    },
    loading: {
      type: Boolean,
    },
  },
  computed: {
    // ...mapGetterObject(storeNS,Distribu),

    contractIds:function(){
      return this.selectedContractDetails?.contractID||[]
    },

    maximumNumberOfContract:function(){
      return this.contractIds.length;
    },
  
    autofetchProjectTV: function () {
      return [
        { text: "On", value: 1 },
        { text: "Off", value: 2 },
      ];
    },
    statuses: function () {
      return this.selectedContractDetails?.label_statuses || [];
    },
    getTopMargin: function () {
      if (this.selectedContractDetails.contract.template_flag) {
        return "0px";
      }

      return "5px";
    },
  },
  methods: {
    onPrevClick:function(){
        if(this.currentContractIdIndex!=0){
          this.currentContractIdIndex--;

          this.openContract(this.contractIds[this.currentContractIdIndex]);

          console.log("::::::::::::::::::",this.contractIds[this.currentContractIdIndex])
        }
    },
    onNextClick:function(){
      if( this.currentContractIdIndex<this.maximumNumberOfContract-1){
        this.currentContractIdIndex++;

        this.openContract(this.contractIds[this.currentContractIdIndex]);

        console.log("::::::::::::::::::",this.contractIds[this.currentContractIdIndex])
      }
    },

    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDateUpdate: function ({ name, value }) {
      this.$emit("changed", { name, value });
    },
    onCheckboxChange: function (name, value) {
      value = value.target.checked ? "1" : "0";
      this[name] = value;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      this.$emit("changed", { name, value: value.value });
    },

    openContract:function(pk){
      this.$router.push({
        name: royaltyContractsListLDTRoutes.names.tab,
        params: {
          contract_id: pk,
          tab: "overview",
        },
      });
    },


    onRoyaltyAccountClick: function () {
      const pk =
        this.selectedContractDetails?.royalty_account?.royalty_account_id || "";
      this.$router.push({
        name: royaltyAccountsListLDTRoutes.names.tab,
        params: {
          royalty_account_id: pk,
          tab: "overview",
        },
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-contract_details {
  margin-bottom: 39px;
  .dt-details--col {
    max-width: 33%;
    .dt-details--row {
      padding-left: 0px !important;
      .no-label {
        .label-title {
          display: none;
        }
      }
    }
  }
}
</style>

